const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withContainerDims = require("../hoc/withContainerDims");
const AT = require("../vault/ActionTypes");
const URLMake = require("../../../shared/URLMake");
const AssetsUtil = require("../util/AssetsUtil");
const Modal = require("./Modal");
const MessageModal = require("./MessageModal");
const StudentLink = require("./Link");
const UnlockUtil = require("../util/UnlockUtil");
const OpsLab = require("../../lab/vault/OpsLab");
const {
	maybeFlushAfterBlockingModal,
} = require("../../trainer/util/ContinuousPlayStreakModalHallwayDispatch");
const ScrollableButtons = require("./ScrollableButtons");
const Sounds = require("../../core/util/Sounds");

const styles = require("./styles/LevelUpModal.css");

// Shows user if they went up a level (level depends on XP, see TrainerCore for calculations)

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component);
	Component = withVaultDispatch(Component);
	Component = withContainerDims(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "LevelUpModal",

		propTypes: {
			user: PT.object.isRequired,
			page: PT.object.isRequired,
			tutorial: PT.object,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			containerDims: PT.shape({
				width: PT.number.isRequired,
				height: PT.number.isRequired,
			}).isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			showLevelUpModal: function(level, lastLevelNotified) {
				if (level > 1) {
					this.setState({
						isModalOpen: true,
						level,
						lastLevelNotified,
					});
				}
			},
			closeLevelUpModal: function() {
				this.setState({isModalOpen: false});
			},
		},

		getInitialState: function() {
			return {
				isModalOpen: false,
				level: null,
				lastLevelNotified: 0,
			};
		},

		componentDidUpdate: function(prevProps, prevState) {
			if (
				!prevState.isModalOpen &&
				this.state.isModalOpen &&
				this.state.lastLevelNotified
			) {
				setTimeout(() => Sounds.playSound("level-up"), 500);
			}
		},

		onClose: function() {
			this.setState({isModalOpen: false});
			this.props.dispatch({
				type: AT.UPDATE_SHOW_NOTIFICATION,
				isShowingNotification: false,
			});
			maybeFlushAfterBlockingModal(this.props.dispatch);
		},

		renderLevel: function(level, hasUnlocked) {
			const levelClass = hasUnlocked ? styles.level : styles.levelOnly;
			return (
				<div className={levelClass}>
					<div className={styles.label}>
						You're on
						<br />
						<span>Level</span>
					</div>
					<div className={styles.levelNum}>
						{level}
						<img
							className={styles.levelShine}
							src={AssetsUtil.getLevelModal("star2")}
						/>
					</div>
				</div>
			);
		},

		renderUnlocked: function(thingsUnlocked) {
			if (!thingsUnlocked) return null;
			const {
				spaces = [],
				puzzleTypes = [],
				beastPartCategories = [],
			} = thingsUnlocked;
			const buttonSize = Math.min(150, this.props.containerDims.width / 8);
			const spaceBadges = spaces.map(s =>
				this.makeBadge(s, "space", buttonSize)
			);
			const puzzleBadges = puzzleTypes.map(p =>
				this.makeBadge(p, "puzzle", buttonSize)
			);
			const beastPartBadges = beastPartCategories.map(c =>
				this.makeBadge(c, "beastPart", buttonSize)
			);
			const buttons = _.concat(spaceBadges, puzzleBadges, beastPartBadges);
			return (
				<div className={styles.unlockedStuff}>
					<div className={styles.unlockedTitle}>
						<img
							className={styles.unlockIcon}
							src={AssetsUtil.getButton("locked-unlocked", "gray")}
						/>
						You've unlocked
					</div>
					<ScrollableButtons
						className={styles.badges}
						buttons={buttons}
						scrollIndex={0}
						numScrollButtons={3}
						selectedIndex={0}
						scrollCutoff={3}
						buttonSize={buttonSize}
						arrowColor="blue"
					/>
				</div>
			);
		},

		makeBadge: function(val, type) {
			let imgSrc;
			let text;
			let linkTo;
			let textClass;
			if (type === "space") {
				imgSrc = AssetsUtil.getLevelModal(val);
				if (val === "lab") linkTo = URLMake.forDefaultLabType();
				if (val === "beastbuilder") linkTo = URLMake.forBeastBuilder();
			} else if (type === "puzzle") {
				imgSrc = AssetsUtil.getLevelModal("unlock-puzzle");
				text = OpsLab.getTypeNameFromID(val);
				linkTo = URLMake.forLabType(val);
				textClass = styles.badgeTextPuzzle;
			} else if (type === "beastPart") {
				imgSrc = AssetsUtil.getLevelModal("unlock-part");
				text = _.capitalize(val[1]);
				linkTo = URLMake.forBeastBuilder();
				textClass = styles.badgeTextBeastPart;
			}
			return (
				<StudentLink
					className={styles.badge}
					key={[type, val].join("-")}
					to={linkTo}
					useWonkyCursor={true}
					clickAction={this.onClose}
				>
					<img src={imgSrc} className={styles.badgeImg} />
					<div className={textClass}>{text}</div>
				</StudentLink>
			);
		},

		renderStarDecor: function(thingsUnlocked) {
			const starSet = className => (
				<div className={className}>
					<img src={AssetsUtil.getLevelModal("star1")} className={styles.st1} />
					<img src={AssetsUtil.getLevelModal("star1")} className={styles.st2} />
					<img src={AssetsUtil.getLevelModal("star1")} className={styles.st3} />
				</div>
			);
			return (
				<div
					className={
						thingsUnlocked ? styles.starsDecorUnlocked : styles.starsDecor
					}
				>
					{starSet(styles.starsLeft)}
					{starSet(styles.starsRight)}
				</div>
			);
		},

		render: function() {
			let modal = null;
			const {user, page} = this.props;
			const {level, lastLevelNotified, isModalOpen} = this.state;
			const thingsUnlocked = UnlockUtil.getAllUnlockedBetweenLevels(
				level,
				lastLevelNotified || 1
			);
			const {spaces = []} = thingsUnlocked || {};
			if (isModalOpen && user && !page.demo) {
				if (!lastLevelNotified && _.includes(spaces, "lab")) {
					// When puzzle lab launches, there might be students on super high levels,
					// we just want to show minimal message for them
					// TODO: we might want to get rid of this once lab has been out for a while
					modal = (
						<MessageModal
							styleType="default"
							onClose={this.onClose}
							closeOnBackdropClick={true}
							closeOnEsc={true}
							hasCloseButton={true}
							backdropClass={styles.backdrop}
							modalClass={styles.message}
							size="medium"
							buttonType="medium-size"
							buttonText={"Got it!"}
						>
							There's a new building on Campus! Click the LAB button on the home
							screen to visit!
						</MessageModal>
					);
				} else if (lastLevelNotified) {
					modal = (
						<Modal
							onClose={this.onClose}
							closeOnBackdropClick={true}
							closeOnEsc={true}
							hasCloseButton={true}
							backdropClass={styles.backdrop}
							modalClass={styles.main}
							levelType="default"
						>
							<img
								className={styles.bg}
								src={AssetsUtil.getModal(
									thingsUnlocked ? "levelup-unlock" : "levelup"
								)}
							/>
							<div className={styles.contents}>
								{this.renderLevel(level, !!thingsUnlocked)}
								{this.renderUnlocked(thingsUnlocked)}
								{this.renderStarDecor(thingsUnlocked)}
							</div>
						</Modal>
					);
				}
			}
			return modal;
		},
	})
);
